import { render, staticRenderFns } from "./SaveButton.vue?vue&type=template&id=99c5b408&"
import script from "./SaveButton.vue?vue&type=script&lang=ts&"
export * from "./SaveButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports